import classNames from 'classnames';
import { FC } from 'react';

import { Checkbox } from '../';

import './CheckboxGroup.scss';

export interface CheckboxOption {
  label: string;
  value: string;
}

export interface CheckboxGroupProps {
  options: CheckboxOption[];
  value: string[];
  onChange: (selectedValues: string[]) => void;
  className?: string;
}

export const CheckboxGroup: FC<CheckboxGroupProps> = ({ options, value, onChange, className }) => {
  const handleCheckboxChange = (optionValue: string, isChecked: boolean): void => {
    const newSelectedValues = isChecked
      ? [...value, optionValue]
      : value.filter((selected) => selected !== optionValue);

    onChange(newSelectedValues);
  };

  return (
    <div className={classNames('checkbox-group', className)}>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={value.includes(option.value)}
          onChange={(e): void => handleCheckboxChange(option.value, e.target.checked)}
        />
      ))}
    </div>
  );
};
